export const iconFontAwesomeUsersPeopleUserCheck = (
	<i className="fa-solid fa-user-check"></i>
);
